import { SeeqNames } from '@seeqdev/constants';

export const WORKBOOK_VERSIONED_ITEM_TYPES = [SeeqNames.Types.Analysis, SeeqNames.Types.Topic];
